// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';
import { type ItemPosition } from './types';
interface StyledCarouselItemProps {
	visiblePosition: ItemPosition;
	currentPosition: ItemPosition;
}

const getCurrentCardPosition = ({
	visiblePosition,
	currentPosition,
}: StyledCarouselItemProps): string => {
	// If the item is at the visible position, it should be at 0
	if (visiblePosition === currentPosition) {
		return '0';
	}
	// If the item is after the visible position, it should be at 100% (to the right)
	if (currentPosition > visiblePosition) {
		return '100%';
	}
	// If the item is before the visible position, it should be at -100% (to the left)
	return '-100%';
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const StyledCarouselSlide = styled.ul({
	position: 'relative',
	listStyle: 'none',
	margin: 0,
	padding: 0,
	display: 'flex',
	width: '100%',
	height: '100%',
	overflow: 'hidden',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-styled-tagged-template-expression -- Ignored via go/DSP-18766
export const StyledCarouselItem = styled.li<{
	visiblePosition: ItemPosition;
	currentPosition: ItemPosition;
}>`
	position: absolute;
	top: 0;
	bottom: 0;
	padding: 0;
	margin: 0;
	width: 100%;
	${(props: StyledCarouselItemProps) => {
		const cardPosition = getCurrentCardPosition(props);
		const isVisible = props.visiblePosition === props.currentPosition;
		return `
				transition: all 0.365s ease-in-out;
			    height: 100%;
            	transform: translateX(${cardPosition});
            	visibility: ${isVisible ? 'visible' : 'hidden'};
            	z-index: ${isVisible ? 1 : 0};
            	pointer-events: ${isVisible ? 'auto' : 'none'};
			`;
	}}
`;
